import React, { ReactNode } from 'react';
import { connect } from 'react-redux';
import { Navigate, useLocation } from 'react-router';

import { GlobalState } from 'reducers';
import { LOGIN_PATH } from './routePaths';
import { getIsAuthenticated } from 'selectors/auth/getIsAuthenticated';
import { getBasicToken } from 'selectors/auth/getBasicToken';

interface StateProps {
  isAuthenticated: boolean;
  basicToken: string;
}

interface OwnProps {
  children: ReactNode;
}

type Props = StateProps & OwnProps;

const mapStateToProps = (state: GlobalState) => ({
  isAuthenticated: getIsAuthenticated(state),
  basicToken: getBasicToken(state),
});

export const PrivateRouteComponent = ({ isAuthenticated, children }: Props) => {
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to={LOGIN_PATH} state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export const PrivateRoute = connect(mapStateToProps)(PrivateRouteComponent);
